import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import { Input, RenderInputFields, SubmitButton,SubInput,
  SubTab } from "../../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    setValue
  } = useForm();

  const { response, request } = useRequest();
  const { languages } = useSelector((state) => state.setting);
  const history = useHistory();
  const [video, setVideo]                                         = useState();
  const [image, setImage]                                         = useState();
  const [displayVideo, setDisplayVideo]                           = useState();
  const [displayImage, setDisplayImage]                           = useState();

  useEffect(() => {
    document.title = "Add Video - Calevalab";
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Video has been added successfully.");
      history.push("/resources/video");
    }
  }, [response]);

  const onSubmit = (data) => {

    const langData                     = [];
    let fd = new FormData();
    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      if (languages[i].default) {
        fd.append("title",  data[`title-${code}`]);
      }

      langData.push({ languageCode:code, title: data[`title-${code}`]});
    }

    if (data.video && data.video.length > 0) {
        fd.append("file", data.video[0]);
    }
    if (data.image && data.image.length > 0) {
      fd.append("image", data.image[0]);
    }
   

    
    fd.append("langData", JSON.stringify(langData));
    request("POST", "resource-video", fd);
  };

  const handleImage = (event) => {
    event.preventDefault();
    if(event.target.files[0]){
        setDisplayImage(URL.createObjectURL(event.target.files[0]))
        setError('image','');
    }else{
        setDisplayImage('');
        setImage('');
        setValue('image','')
    }
  }

  const handleRemoveImage = () => {
    if (displayImage) {
        setDisplayImage(null);
        setValue("image", null);
    } else {
        setImage(null);
    }
  }
  const handleVideo = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayVideo(URL.createObjectURL(event.target.files[0]));
      setError("video", "");  
    } else {
      setDisplayVideo("");  
      setVideo("");  
      setValue("video", ""); 
    }
  };
  const handleRemoveVideo = () => {
    if (displayVideo) {
      setDisplayVideo(null);  
      setValue("video", null);  
    } else {
      setVideo(null); 
    }
  };
  
  const InputFields = [
    [
      {
        Component: Input,
        label: "Title",
        type: "text",
        name: "title",
        registerFields: {
          required: true,
        },
      },
    ],
  ];

  const InputFieldsImage = [
   
    [
      { 
        Component: Input,
        label: "Video", 
        type: "file", 
        name: "video", 
        registerFields: {
          required: true,  
        },
        handleMedia: handleVideo, 
        handleRemoveMedia: handleRemoveVideo,  
        isMedia: true,  
        accept: "video/*",  
        control, 
        video,
        displayVideo,  
        media: "video", 
        mediaClass: "video-tab-media" 
      },
      { 
        Component: Input,
        label: "Image",
        type: "file",
        name: "image",
        registerFields: {
          required: true
        },
        handleMedia:handleImage,
        handleRemoveMedia:handleRemoveImage,
        isMedia:true,
        accept:"image/*",
        control,
        image,
        displayImage,
        media:'image',
        mediaClass:"image-tab-media"
      }
    ],
    
    
  ];


  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Video"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/resources/video", name: "Back To Videos" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Video
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                             ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  InputFields={InputFields}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>
                    
                    <RenderInputFields
                      InputFields={InputFieldsImage}
                      errors={errors}
                      register={register}
                    />
                      
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
